import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { PIDataUpload } from './pi-data-upload';
import { IState, IUploadState } from '../../../interfaces';

export interface IPIDataUploadStateProps {
  readonly upload: IUploadState;
}

export type IPIDataUploadConnectProps = IPIDataUploadStateProps & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState): IPIDataUploadStateProps {
  return { upload: state.upload };
}

export const PIDataUploadContainer: React.ComponentClass
  = ReactRedux.connect(mapStateToProps)(PIDataUpload);
